import { isServer } from "solid-js/web";

interface Window {
  ReactNativeWebView?: unknown;
}

export const rnPostMessage = (message: { [key: string]: unknown }) => {
  if (!isServer) {
    try {
      const isRN = typeof (window as Window).ReactNativeWebView !== "undefined";

      if (isRN) {
        // RN
        window?.ReactNativeWebView?.postMessage(JSON.stringify(message));
      } else {
        // IOS
        window?.webkit?.messageHandlers?.jsBridge?.postMessage(
          JSON.stringify(message),
        );
      }
    } catch (error) {
      console.error("[TWA] 发送消息失败:", error);
    }
  }
};

export const updateRnToken = (token: string) => {
  rnPostMessage({ cmd: "update_token", params: { token } });
};

export const updateLang = (lang: string) => {
  rnPostMessage({ cmd: "update_lang", params: { lang } });
};

export const openAppBrowser = (url: string) => {
  rnPostMessage({ cmd: "openAppBrowser", params: { url } });
};
